import React from "react";
import EditableText from "./EditableText";
import { contactInfo, trustInfo } from "../mock";

const Footer = () => {
  return (
    <footer className="w-full bg-[#3a2c25] text-[#e8d9c4] py-10">
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center md:items-start justify-between gap-6">
        <div className="text-center md:text-left">
          <EditableText id="footer.name" as="p" className="font-bold text-lg"
             style={{ fontFamily: "'Quicksand', system-ui, sans-serif" }}>
            {`${trustInfo.name}\u00ae`}
          </EditableText>
          <EditableText id="footer.reg" as="p" className="text-sm opacity-80 mt-1">
            {`Registration No. ${trustInfo.registrationNo}`}
          </EditableText>
        </div>
        <div className="text-center md:text-right text-sm opacity-90">
          <EditableText id="footer.address" as="p" multiline className="block whitespace-pre-line">
            {contactInfo.address}
          </EditableText>
          <EditableText id="footer.contact" as="p" className="mt-1">
            {`${contactInfo.mobile} \u2022 ${contactInfo.email}`}
          </EditableText>
          <p className="mt-3 text-xs opacity-60">© {new Date().getFullYear()} Sharada Rama Rao Trust. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
